const translations = {
    applicationSite: 'Application Site ({{number}})'
};

export default translations;
